// Razorpay Checkout (https://razorpay.com/docs/payments/payment-gateway/web-integration/standard/): loads the
// script once and opens the payment window for an order the server created (fpo PaymentController). Resolves
// with {status: "paid", orderId, paymentId, signature} when Razorpay reports success — the server still verifies
// it before anything is given — {status: "closed"} when the window is closed, or {status: "failed", reason}.
// The secret key never comes to the browser; the order data carries only the public key id.

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";
let loading = null;

function loadScript() {
  if (window.Razorpay) return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SCRIPT;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => { loading = null; reject(new Error("Could not load Razorpay. Check your internet connection.")); };
      document.body.appendChild(s);
    });
  }
  return loading;
}

/** @param order the server's Checkout data: keyId, orderId, amount, currency, name, description, prefill */
export async function openRazorpayCheckout(order) {
  await loadScript();
  return new Promise((resolve) => {
    let settled = false;
    const done = (result) => { if (!settled) { settled = true; resolve(result); } };
    const rzp = new window.Razorpay({
      key: order.keyId,
      order_id: order.orderId,
      amount: order.amount,
      currency: order.currency || "INR",
      name: order.name || "FEED",
      description: order.description,
      prefill: order.prefill || {},
      theme: { color: "#1f7a3d" },
      handler: (r) => done({
        status: "paid",
        orderId: r.razorpay_order_id,
        paymentId: r.razorpay_payment_id,
        signature: r.razorpay_signature,
      }),
      modal: {
        // Closed after a failed attempt (Razorpay keeps the window open for another try): report the failure
        ondismiss: () => done(rzp.__lastFailure ? { status: "failed", reason: rzp.__lastFailure } : { status: "closed" }),
        confirm_close: true,
      },
    });
    rzp.on("payment.failed", (r) => {
      rzp.__lastFailure = r?.error?.description || "The payment failed.";
    });
    // Razorpay shows its window in the language of <html lang>: make that the language chosen with the app's
    // selector (Google Translate's "googtrans" cookie), English when none was chosen
    const chosen = ((document.cookie.match(/(?:^|;\s*)googtrans=([^;]*)/) || [])[1] || "").split("/").pop();
    document.documentElement.lang = ["te", "hi"].includes(chosen) ? chosen : "en";
    rzp.open();
  });
}

/** "₹1,180.00" */
export const rupees = (v) =>
  v == null ? "" : "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
